import * as React from 'react';

import {HelpModal} from 'shells/modal/help-modal';

import {UtmParametersHelpGraphic} from './assets/utm-parameters-help-graphic';
import {UtmHelp} from './utm-help';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function UtmHelpModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            bodyComponent={<UtmHelp />}
            artImage={<UtmParametersHelpGraphic />}
        />
    );
}
